export const BLOB_CONFIG = {
  background: '#ffffff',
  gradientMap: '4',
  gradientColor1: '#ffb3ba',
  gradientColor2: '#bae1ff',
  gradientColor3: '#b8e6b8',
  uPositionFrequency: 3,
  uPositionStrength: 2,
  uSmallWavePositionFrequency: 2.18,
  uSmallWavePositionStrength: 0.18,
  uSmallWaveTimeFrequency: 0.11,
  uTimeFrequency: 0,
  roughness: 0.49,
  metalness: 0,
  envMapIntensity: 0,
  clearcoat: 0,
  clearcoatRoughness: 0,
  transmission: 0,
  wireframe: false,
  flatShading: true,
  autoRotate: true,
  autoRotateSpeed: 0.1,
};
